import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Autocomplete, TextField, Button } from '@mui/material';

const AssignStudentsDialogue = ({ open, onClose, studentList, selectedStudents, setSelectedStudents, onAssign }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Assign Course</DialogTitle>
      <DialogContent>
        <Autocomplete
          multiple
          options={studentList}
          getOptionLabel={(option) => 
            option.student_name || 
            option.authname || 
            option.username || 
            option.name || 
            `User ${option.studentId || option.userid}`
          }
          value={selectedStudents}
          onChange={(event, newValue) => setSelectedStudents(newValue)}
          isOptionEqualToValue={(option, value) => 
            (option.studentId || option.userid) === (value.studentId || value.userid)
          }
          renderInput={(params) => (
            <TextField {...params} label="Select People" placeholder="Search..." variant="outlined" margin="normal" />
          )}
          sx={{ mt: 2 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onAssign} variant="contained" disabled={selectedStudents.length === 0}>
          Assign
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssignStudentsDialogue;
